import { fy2025_26 } from "./fy2025-26.js";
import type { IncomeTaxRuleSet } from "./types.js";

// income-tax ruleset for FY2026-27 (1 July 2026 – 30 June 2027).
//
// THE ONLY CITED FY2026-27 change is the legislated second-bracket rate cut:
// the 16% rate on $18,201–$45,000 is reduced to **15%** from 1 July 2026
// (Treasury Laws Amendment (Cost of Living Tax Cuts) Act 2024, phase 2 of 3;
// take-home-pay ledger #2, CITED — "From 1 July 2026, the 16% rate will be
// reduced to 15%"). A further 15%→14% cut lands 1 July 2027 (FY2027-28), which
// is a FUTURE ruleset, not this one.
//
// ⚠️ DOCUMENTED ASSUMPTION (not yet verified for FY2026-27):
// Medicare-levy low-income thresholds, LITO, SAPTO, the part-year threshold,
// and the HELP/STSL bands all index annually (AWE / CPI). The verification
// ledgers only confirmed the 2025-26 values and the bracket cut — they did NOT
// publish 2026-27 indexed figures (most are set at the 2026-27 Budget). This
// ruleset therefore CARRIES FORWARD the FY2025-26 values for everything except
// the bracket cut, so the engine is usable for FY2026-27 take-home estimates.
// Before this ships as authoritative for 2026-27, re-verify each carried-forward
// figure against the ATO/Budget and overwrite below — do NOT assume they held.
export const fy2026_27: IncomeTaxRuleSet = {
  ...fy2025_26,
  fy: "2026-27",
  effectiveFrom: "2026-07-01",
  effectiveTo: "2027-06-30",
  sources: {
    ...fy2025_26.sources,
    taxCuts:
      "https://www.ato.gov.au/about-ato/new-legislation/in-detail/individuals/personal-income-tax-new-tax-cuts-for-every-australian-taxpayer",
  },
  sourcesVerifiedAt: "2026-06-22",

  // CITED change: 16% → 15% on $18,201–$45,000 from 1 July 2026.
  residentBrackets: [
    { from: 0, to: 18_201, rate: 0 },
    { from: 18_201, to: 45_001, rate: 0.15 },
    { from: 45_001, to: 135_001, rate: 0.3 },
    { from: 135_001, to: 190_001, rate: 0.37 },
    { from: 190_001, to: null, rate: 0.45 },
  ],

  // Everything else (foreignBrackets, whmBrackets, medicareLevy, lito, sapto,
  // partYearThreshold, helpMinThreshold, helpBands, taxFreeThreshold) is spread
  // from fy2025_26 above as the DOCUMENTED carry-forward assumption. Re-verify
  // and override before treating FY2026-27 output as authoritative.
};
